import { api, setConfig, UPDATE_GAME_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const addGameCategory = (data: PropertyType): Promise<PropertyType> =>
	api.post('/games/category', mapEntityToApi(data), setConfig(data)).then(() => {
		return { message: UPDATE_GAME_MESSAGE };
	});
